import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { FaDownload  } from 'react-icons/fa';
import data from "./data";
import React, { useEffect} from "react";
import StickersPage from './components/StickersPage';
import Faq from './components/Faq';
import {BrowserRouter, Routes, Route} from 'react-router-dom'


function App() {

  useEffect(() => {
    document.title = "Stickere Steaua";  
  }, []);



  return (
    <BrowserRouter basename='/'>
      <Routes>
        <Route index element={<StickersPage/>}/>
        <Route path="faq" element={<Faq/>}/>
        
      </Routes>
    </BrowserRouter>
  );

}

export default App;
